import React from 'react';

import {Separator} from 'src/components/separator';
import {ChangeLogItem} from 'src/modules/event/views/change-log/change-log-item';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

import {Group, Item} from '@pb/kit-component-group';
import {Scrollable} from '@pb/kit-component-scrollable';

import {changeLogList} from './change-log.module.styl';

type Props = {
    changeRequests: Array<ChangeRequest>,
};

const NO_CHANGES_MADE = 'No changes made to this event';

export const ChangeLog = ({changeRequests}: Props) => {
    return (
        <Group direction="v" gap="none">
            <Item className="pb-m">
                <strong>Change Log:</strong>
            </Item>
            <Separator/>
            <Item className="pt-s">
                <Item className="pb-s">
                    <Group>
                        <Item style={{width: '9rem'}}><strong>Last Updated</strong></Item>
                        <Item style={{width: 'calc(80% - 15rem)'}}><strong>Author</strong></Item>
                        <Item style={{width: '15rem'}}><strong>Status</strong></Item>
                    </Group>
                </Item>
                <Separator/>
            </Item>
            {changeRequests.length ? (
                <Scrollable absolute={true} mix={changeLogList}>
                    {changeRequests.map(row => (
                        <ChangeLogItem key={row.id} changeRequest={row}/>
                    ))}
                </Scrollable>
            ) : (
                <Item className="pt-s">
                    {NO_CHANGES_MADE}
                </Item>
            )}
        </Group>
    );
};
